import React from 'react';

import {
  Dialog,
  CommonDialogLayout,
  ProgressingDialogHead,
} from '@wwe-portal/ui/components/dialog';
import { Button } from '@wwe-portal/ui/components/button';

export interface ReferSubscriptionDialogProps {
  onClose?: () => void;
  onChange?: () => void;
  open?: boolean;
  description?: React.ReactNode;
}
export function ReferSubscriptionDialog({
  onClose,
  onChange,
  open = true,
  description,
}: Readonly<ReferSubscriptionDialogProps>) {
  return (
    <Dialog
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose?.();
      }}
      open={open}
    >
      <CommonDialogLayout
        actionElement={
          <div className="flex justify-center">
            <Button
              className="w-full max-w-[178px] truncate text-xs font-semibold"
              onClick={onChange}
              variant="orange"
            >
              GO TO SUBSCRIPTION
            </Button>
          </div>
        }
        closable
        dataId="ReferSubscriptionDialog"
        descriptionElement={description}
        imageElement={
          <ProgressingDialogHead duration={0} progressPercent={0} />
        }
        onClose={onClose}
        titleElement={undefined}
      />
    </Dialog>
  );
}

export default ReferSubscriptionDialog;
